
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M50 27a4 4 0 014 4v18a4 4 0 01-4 4H14a4 4 0 01-4-4V31a4 4 0 014-4h36zm0 2H14a2 2 0 00-1.987 1.767L12 31v18a2 2 0 001.767 1.987L14 51h36a2 2 0 001.987-1.767L52 49V31a2 2 0 00-1.767-1.987L50 29zm-4 12a2 2 0 110 4 2 2 0 010-4zm-29 2a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm-9-22v2h-2a2 2 0 00-1.987 1.767L12 25v.535a4 4 0 00-1.986 3.127L10 29v-4a4 4 0 014-4h2zm34 0a4 4 0 014 4v4c0-1.48-.803-2.772-1.998-3.464L52 25a2 2 0 00-1.767-1.987L50 23l-2-.002V21h2zm-8-10c.16 0 .32.01.476.028l.195-.017L43 11a5 5 0 013.002 8.999L46 25H18v-5a5 5 0 013.526-8.973C21.68 11.01 21.84 11 22 11h20zm1.065 1.999l-.217.004-.196.017-.412-.006-.119-.01H21.878l-.122.01-.438.003a3 3 0 00-2.356 5.185l.24.2.798.6L19.998 23H44l.002-4 .798-.6A2.992 2.992 0 0046 16c0-1.56-1.19-2.84-2.657-2.987l-.278-.014z"}})])
          )
        }
      }
    